import Reviews from './reviews'
import Product from './product';
import FacebookItemNewTab from './Component/FacebookItemNewTab';


const reviewsConfig = {
    settings: {
      layout: {},
    },
    routes: [
      {
        path: 'views',
        element: <Product />,
      },
      {
        path: 'fb-post',
        element: <FacebookItemNewTab />,
      },
    ],
  };
  
  export default reviewsConfig;
